import type { ScreenSize } from "@circle-react-shared/ScreenSizeSelect";
import { SelectRadioGroup } from "@circle-react-uikit/SelectRadioGroup";
import { Typography } from "@circle-react-uikit/Typography";
import { Header } from "../Header";
import type { HeaderProps } from "../Header/Header";
import { useCustomizeUIData } from "../Provider";

export interface DefaultHeaderViewProps extends HeaderProps {
  currentScreenSize?: ScreenSize;
  currentSection?: string;
  formId?: string;
  isSaving?: boolean;
  onChangeScreenSize: (size: ScreenSize) => void;
  onChangeSection: (section: string) => void;
  onExit: () => void;
  onSave: () => void;
  sections?: string[];
  shouldShowActions?: boolean;
  title?: string;
}

export const DefaultHeaderView = ({
  currentScreenSize = "desktop",
  currentSection = "",
  formId = "",
  onChangeScreenSize,
  onChangeSection,
  onExit,
  onSave,
  sections = [],
  title = "",
  isSaving = false,
  shouldShowActions = true,
  ...rest
}: DefaultHeaderViewProps) => {
  const { isSaveButtonDisabled } = useCustomizeUIData();

  const radioOptions = sections.map(value => ({
    value,
    label: value,
  }));

  return (
    <Header {...rest}>
      <Header.Actions className="!gap-4">
        <Header.ExitButton onClick={onExit} />
        {title && (
          <Typography.LabelMd weight="semibold">{title}</Typography.LabelMd>
        )}
      </Header.Actions>
      <Header.Actions>
        <SelectRadioGroup
          value={currentSection}
          onChange={onChangeSection}
          options={radioOptions}
        />
      </Header.Actions>
      {shouldShowActions && (
        <Header.Actions>
          <Header.ScreenSizeSelect
            onSelect={onChangeScreenSize}
            selected={currentScreenSize}
          />
          <Header.SaveButton
            onClick={onSave}
            formId={formId}
            disabled={isSaving || isSaveButtonDisabled}
            variant="circle"
          />
        </Header.Actions>
      )}
    </Header>
  );
};
